export default "__VITE_ASSET__uX3DuNQQ__"